import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import api from '../../../utils/api'
import { CategoryType } from '../../../components/Category'
import ApplicationNote from './ApplicationNote/ApplicationNote'
import Publication from './Publication/Publication'
import Blog from './Blog/Blog'
import { getTags } from '../../../partials/Post/utils'
import Resources from '../Resources'

const ResourceWrapper = () => {
    const { resourceId, category } = useParams()
    const [resource, setResource] = useState(null)
    const [tags, setTags] = useState<string[]>([])

    useEffect(() => {
        if (resourceId) {
            const query = `/wp-json/wp/v2/posts?_embed&slug=${resourceId}`
            api.get(query).then(({ data }) => {
                setResource(data[0])
                setTags(getTags(data[0]) ?? [])
            })
        }
    }, [resourceId])

    if (category && !resourceId) {
        return <Resources />
    }

    const getPage = () => {
        switch (category) {
        case CategoryType.CASE_STUDY:
        case CategoryType.APPLICATION_NOTE:
            return (
                <ApplicationNote resource={resource} category={category as CategoryType} tags={tags} />
            )
        case CategoryType.PUBLICATION:
            return <Publication resource={resource} tags={tags} />
        default:
            return <Blog resource={resource} category={category as CategoryType} tags={tags} />
        }
    }
    return getPage()
}

export default ResourceWrapper
